import { isMobile } from "react-device-detect";

export const useDetectMobile = (): boolean => {
  return isMobile;
};
